<template>
  <div class="validate-domain">
    <div class="d-flex align-items-center justify-content-center vh-100 text-center">
      <div>
        <h2 class="text-danger">Invalid or missing client domain.</h2>
        <p>Please access the application using a valid client subdomain.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidateDomain'
}
</script>

<style scoped>
.validate-domain {
  font-family: sans-serif;
}
</style>
